
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6M71K", function(module, exports) {
/**
 * @generated SignedSource<<4c021c6a1ed1e30b20e3b67fb4ea22e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ecbb6e526a968754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$ecbb6e526a968754$var$node.hash = "f4093e7916c35c0c1b9141fd35c3dbe3";
var $ecbb6e526a968754$export$2e2bcd8739ae039 = $ecbb6e526a968754$var$node;


/**
 * @generated SignedSource<<69adaaa975d3bb98285d89324cde2376>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2114907496ee9554$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$2114907496ee9554$var$node.hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";
var $2114907496ee9554$export$2e2bcd8739ae039 = $2114907496ee9554$var$node;


/**
 * @generated SignedSource<<6f1560a1e596d5aeac087b552ac1fdc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $896ad30c32f2cdd3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$896ad30c32f2cdd3$var$node.hash = "05d2a2275047024b0d469ae534b88e41";
var $896ad30c32f2cdd3$export$2e2bcd8739ae039 = $896ad30c32f2cdd3$var$node;


/**
 * @generated SignedSource<<bbec80b8d7ffb4e36b6143c20c7fdacc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fd779f9cf97f4fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$5fd779f9cf97f4fb$var$node.hash = "24af67d646910e1784019b6a037f34e4";
var $5fd779f9cf97f4fb$export$2e2bcd8739ae039 = $5fd779f9cf97f4fb$var$node;



var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7bZ3i = parcelRequire("7bZ3i");


var $a2xFu = parcelRequire("a2xFu");

const $89aa0ef6b16bedeb$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $89aa0ef6b16bedeb$export$97f4c254b641e719 = (hostname)=>!$89aa0ef6b16bedeb$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $89aa0ef6b16bedeb$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $89aa0ef6b16bedeb$export$280e79c794cf814e = (url)=>$89aa0ef6b16bedeb$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $89aa0ef6b16bedeb$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $a2xFu.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $89aa0ef6b16bedeb$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $89aa0ef6b16bedeb$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $89aa0ef6b16bedeb$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $89aa0ef6b16bedeb$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$89aa0ef6b16bedeb$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};



var $6mKj3 = parcelRequire("6mKj3");


var $lhTEt = parcelRequire("lhTEt");


var $i6Ps3 = parcelRequire("i6Ps3");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $gz8ZY = parcelRequire("gz8ZY");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $6JLuV = parcelRequire("6JLuV");

const $7ac1c4b85cd786d3$export$d48d5704d1181ce6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    let t0;
    let t1;
    if ($[0] !== open) {
        t0 = ()=>{
            const handleMessage = (event)=>{
                const { payload: payload } = event.data;
                if (event.data?.type !== "OPEN_PREVIEW_PANEL") return;
                if (payload?.url) open(payload);
            };
            window.addEventListener("message", handleMessage);
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        };
        t1 = [
            open
        ];
        $[0] = open;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return null;
} : ()=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    // Listen for messages from iframes to open preview panels
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { payload: payload } = event.data;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            if (payload?.url) open(payload);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        open
    ]);
    return null;
};






var $27fJD = parcelRequire("27fJD");


var $cEgMD = parcelRequire("cEgMD");


var $e4o8D = parcelRequire("e4o8D");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $k00oi = parcelRequire("k00oi");


var $477dG = parcelRequire("477dG");

var $egwA4 = parcelRequire("egwA4");




const $de526bdbda89b480$var$deferIdle = (cb)=>{
    if ('requestIdleCallback' in window) requestIdleCallback(cb, {
        timeout: 5000
    });
    else requestAnimationFrame(cb);
};
class $de526bdbda89b480$export$385f1396b754ac80 extends (0, $k00oi.default) {
    // Called once per page load
    prefetchData(url) {
        return super.prefetchData(url).then((data)=>{
            // Using deferIdle(requestIdleCallback) to ensure our onResolve callback doesn't interrupt the smart card client.
            // This means there's a chance under heavy browser load that the delay between client (pre)fetch and onResolve invocation will be >1s, but usually it shouldn't be.
            // Given the data schema is unstable, we're setting the type as unknown and expecting individual resolvers to be mindful.
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    // Called on load and on click of each smart card link
    async fetchData(url, force) {
        if (!force || this.smartCardLocalCacheClient?.isUrlInCache(url) && (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) return this.editorCardProvider.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        }).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
        return super.fetchData(url, force).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    constructor(props){
        const { onResolve: onResolve, envKey: envKey } = props;
        super(envKey);
        this.onResolve = void 0;
        this.editorCardProvider = void 0;
        // When cleaning up platform_editor_smartlink_local_cache, remove ? here and in other places in this file
        this.smartCardLocalCacheClient = void 0;
        this.getInitialCardStoreFromCache = ()=>{
            const initialStateCardStore = {};
            const cachedData = this.smartCardLocalCacheClient?.getCache() ?? {};
            Object.entries(cachedData).forEach(([url, data])=>{
                initialStateCardStore[url] = {
                    status: 'resolved',
                    details: data.data,
                    metadataStatus: 'resolved'
                };
            });
            return initialStateCardStore;
        };
        this.onResolve = onResolve;
        // Because Card components uses data from client and it's super hard to pass EditorCardProvider to them,
        // we will create a new EditorCardProvider instance here and use it for SSR support.
        this.editorCardProvider = new (0, $477dG.EditorCardProvider)(this.envKey, this.baseUrlOverride, 'CONFLUENCE');
        if ((0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) this.smartCardLocalCacheClient = new (0, $egwA4.SmartCardLocalCacheClient)();
        else this.smartCardLocalCacheClient = undefined;
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[this.editorCardProvider.name];
        this.editorCardProvider.setSSRData(ssrData);
    }
}



var $9sGCn = parcelRequire("9sGCn");

const $901e3ce3ee925fd9$var$getContentIdFromResolvedData = (resolvedData)=>{
    const ari = resolvedData.data['atlassian:ari'];
    return ari?.substring?.(ari?.lastIndexOf?.('/') + 1);
};
// data.data['@type'] will have two elements, for example ['schema:DigitalDocument', 'Document'], where 'schema:DigitalDocument' specifically denotes a live doc
// The resolve logic doesn't consistently position these two elements in the @type array, so the schema we need to validate may be in the 0th or 1st element
const $901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc = (resolvedData)=>{
    const typeArr = resolvedData.data['@type'];
    const isLiveDoc = typeArr?.[0] === 'schema:DigitalDocument' || typeArr?.[1] === 'schema:DigitalDocument';
    const isArchived = resolvedData.data['atlassian:state'] === 'archived';
    return isLiveDoc && !isArchived;
};
const $901e3ce3ee925fd9$var$isResolvedDataValid = (resolvedData)=>{
    if (!resolvedData || typeof resolvedData !== 'object') return false;
    const data = resolvedData.data;
    const meta = resolvedData.meta;
    if (!data || !meta) return false;
    if (!('@context' in data)) return false;
    const type = data['@type'];
    if (typeof type !== 'string' && !Array.isArray(type)) return false;
    return true;
};
let $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = false;
const $901e3ce3ee925fd9$export$e1f1443d16a1c263 = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, resolvedData)=>{
    if ($901e3ce3ee925fd9$var$isResolvedDataValid(resolvedData)) {
        if ($901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc(resolvedData)) {
            const contentId = $901e3ce3ee925fd9$var$getContentIdFromResolvedData(resolvedData);
            if (contentId) {
                let existingCachedData;
                try {
                    existingCachedData = readFragmentInterop({
                        id: `Content:${contentId}`
                    });
                } catch  {
                // readFragment throws an error if no data is found
                }
                // Reads are cheaper than writes, so only write if we don't already have the correct data in cache.
                if (!existingCachedData || existingCachedData?.subType !== 'live' || existingCachedData?.status !== 'current') {
                    writeFragmentInterop({
                        fragmentId: `Content:${contentId}`,
                        // status is current if we are an unarchived live doc
                        data: {
                            __typename: 'Content',
                            id: contentId,
                            subType: 'live',
                            status: 'current'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        }
    } else // If resolved data schema is invalid, we likely need to update it ASAP as Linking Platform's content resolver service API may have changed
    if (!$901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'invalidResolverData',
                actionSubject: 'liveDocSmartCardResolver',
                source: 'confluenceSmartCardProvider'
            }
        }).fire();
        // Only send this event once per load to reduce load on analytics pipeline
        $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = true;
    }
};


// Only log first error to console, to prevent spamming console with resolver errors
let $3c75c8f77ed4b940$var$hasLoggedResolverError = false;
const $3c75c8f77ed4b940$var$defaultConfluenceResolveHandler = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)=>{
    try {
        // NOTE FOR DEVS OF RESOLVERS: The `data` object comes from linking platform's content resolver service which is an UNSTABLE API SCHEMA.
        // Ensure your resolver logic handles invalid schemas gracefully and is able to notify your team if the schema changes and your code needs to be updated.
        (0, $901e3ce3ee925fd9$export$e1f1443d16a1c263)(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data);
    } catch (resolverError) {
        // prevent errors from causing smart card provider issues
        if (!$3c75c8f77ed4b940$var$hasLoggedResolverError) {
            const logger = (0, $7W8i8.getLogger)('ConfluenceSmartCardProvider');
            logger.error`resolver error: ${resolverError}`;
            $3c75c8f77ed4b940$var$hasLoggedResolverError = true;
        }
    }
};
const $3c75c8f77ed4b940$var$computeInitialStateFromCache = (smartCardClient)=>{
    if ((0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) // On page transition create the initial CardStore from Cache
    return !(0, $i6Ps3.isPageSSRd)() && smartCardClient instanceof (0, $de526bdbda89b480$export$385f1396b754ac80) ? smartCardClient.getInitialCardStoreFromCache() : null;
    else return null;
};
const $3c75c8f77ed4b940$var$CurrentSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5fd779f9cf97f4fb$export$2e2bcd8739ae039)
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $896ad30c32f2cdd3$export$2e2bcd8739ae039)
    });
    const smartCardClient = (0, $42omo.useMemo)(()=>props?.client || new (0, $de526bdbda89b480$export$385f1396b754ac80)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        ...props
    });
};
const $3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $2114907496ee9554$export$2e2bcd8739ae039)
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ecbb6e526a968754$export$2e2bcd8739ae039)
    });
    const smartCardClient = (0, $42omo.useMemo)(()=>props?.client || new (0, $de526bdbda89b480$export$385f1396b754ac80)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    const initialStateFromCache = (0, $42omo.useRef)($3c75c8f77ed4b940$var$computeInitialStateFromCache(smartCardClient));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? initialStateFromCache?.current ?? window['__SSR_SMARTLINKS__'] : window['__SSR_SMARTLINKS__'];
    const internalStoreOptions = (0, $lhTEt.useStoreOptions)(initialState, isPageSSR);
    // Merge smartlink SSR data with any passed-in storeOptions (e.g. from shortcuts preloader)
    const presetInitialState = {
        ...internalStoreOptions,
        ...props.storeOptions ? {
            storeOptions: {
                ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false ? internalStoreOptions.storeOptions || {} : {},
                ...props.storeOptions,
                ...internalStoreOptions.storeOptions?.initialState && (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? {
                    initialState: {
                        ...internalStoreOptions.storeOptions.initialState,
                        ...props.storeOptions.initialState
                    }
                } : {}
            }
        } : {}
    };
    const shouldControlDataExport = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.PDF_EXPORT_PAGE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        isPreviewPanelAvailable: props.isPreviewPanelAvailable,
        openPreviewPanel: props.openPreviewPanel,
        ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? {} : presetInitialState,
        ...props,
        ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? presetInitialState : {}
    });
};
const $3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider = (props)=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Create a wrapper function that updates the preview panel URL
    // This is used for custom domains to update to the correct content URL and avoid CSP issues
    const openPreviewPanelWithModifiedURL = (0, $42omo.useMemo)(()=>{
        if (!cloudId) return open;
        return ({ url: url, ari: ari, ...rest })=>open({
                url: (0, $89aa0ef6b16bedeb$export$193bb0d0d16ee7a7)(cloudId, url, ari),
                ari: ari,
                ...rest
            });
    }, [
        open,
        cloudId
    ]);
    const { children: children, doNotUsePreviewPanels: doNotUsePreviewPanels, ...restProps } = props;
    return (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || doNotUsePreviewPanels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, restProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, {
        openPreviewPanel: openPreviewPanelWithModifiedURL,
        isPreviewPanelAvailable: renderServerPlaceholder && (0, $9wGTI.fg)('confluence_fix_smartlink_hydration_error') ? (_ari)=>false : (0, $27fJD.isPreviewPanelAvailable),
        ...restProps
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ac1c4b85cd786d3$export$d48d5704d1181ce6), null));
};
const $3c75c8f77ed4b940$export$a56ebeb3c828cd38 = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) return isNav4Enabled && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$CurrentSmartCardProvider, props);
};
module.exports["ConfluenceSmartCardProvider"] = $3c75c8f77ed4b940$export$a56ebeb3c828cd38;

});

parcelRegister("lhTEt", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6mKj3 = parcelRequire("6mKj3");

const $b667503c95136f0a$export$53d21446ea17fdf1 = (initialState, isPageSSRd)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if (initialState && (isPageSSRd || (0, $6mKj3.expValEquals)("platform_editor_smartlink_local_cache", "isEnabled", true))) {
        let t1;
        if ($[0] !== initialState) {
            t1 = {
                storeOptions: {
                    initialState: initialState
                }
            };
            $[0] = initialState;
            $[1] = t1;
        } else t1 = $[1];
        t0 = t1;
    } else {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {};
            $[2] = t1;
        } else t1 = $[2];
        t0 = t1;
    }
    return t0;
};
module.exports["useStoreOptions"] = $b667503c95136f0a$export$53d21446ea17fdf1;

});

parcelRegister("i6Ps3", function(module, exports) {
// Returns true on SSR and SPA if page was SSR'd
const $70ad96d323d38e4d$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(window.__SSR_RENDERED__);
};
module.exports["isPageSSRd"] = $70ad96d323d38e4d$export$a8c2f05884e8c7a1;

});

parcelRegister("6JLuV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eIleF = parcelRequire("eIleF");


var $k4HRJ = parcelRequire("k4HRJ");

var $a2xFu = parcelRequire("a2xFu");

var $eMqrF = parcelRequire("eMqrF");

var $b8JCF = parcelRequire("b8JCF");

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");


var $dj7jL = parcelRequire("dj7jL");

var $1DfVr = parcelRequire("1DfVr");


var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $irOoi = parcelRequire("irOoi");


var $fwXBL = parcelRequire("fwXBL");


var $gJsgh = parcelRequire("gJsgh");


var $8jHAi = parcelRequire("8jHAi");


var $bVHZY = parcelRequire("bVHZY");


var $1dKyn = parcelRequire("1dKyn");


var $ZDq1z = parcelRequire("ZDq1z");


var $2qVkt = parcelRequire("2qVkt");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $dh538 = parcelRequire("dh538");





var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


const $d2a6d778f42989cd$export$a50c261b4b52f403 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("io4wE"))), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});



var $4TXTZ = parcelRequire("4TXTZ");








var $2JrHF = parcelRequire("2JrHF");

const $ac6dd892357cddb5$var$fetchPolicy = 'network-only';

const $ac6dd892357cddb5$var$atlasGoalEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("fm8ka")).then((mod)=>mod.GoalPanel), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $4TXTZ.default)('townsquare-goal-panel-opened');
        return {
            queries: {
                queryReference: {
                    parameters: $2JrHF.default,
                    variables: {
                        ari: ari
                    },
                    options: {
                        fetchPolicy: $ac6dd892357cddb5$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $ac6dd892357cddb5$export$2e2bcd8739ae039 = $ac6dd892357cddb5$var$atlasGoalEntryPoint;









const $1a4e8a680740cd08$var$objectPreviewPanelEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("a4tVd")).then((mod)=>mod.ObjectPreviewPanel), {
        moduleId: "bb3d75a4",
        priority: "interaction",
        moduleId: 'object-preview-panel-entrypoint'
    }),
    getPreloadProps: ({})=>({})
});
var $1a4e8a680740cd08$export$2e2bcd8739ae039 = $1a4e8a680740cd08$var$objectPreviewPanelEntryPoint;



var $4BDAe = parcelRequire("4BDAe");


var $c6GJD = parcelRequire("c6GJD");











var $fff9r = parcelRequire("fff9r");

const $b6e606f8c0a01996$var$fetchPolicy = 'network-only';

const $b6e606f8c0a01996$var$atlasProjectEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("iBezP")).then((mod)=>mod.ProjectPanel), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $4TXTZ.default)('townsquare-project-panel-opened');
        // check for M0 or greater
        const isProjectNativeIntegrationEnabled = (0, $c6GJD.default).getExperimentValue('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0;
        return {
            queries: {
                queryReference: {
                    parameters: $fff9r.default,
                    variables: {
                        ari: ari,
                        isProjectNativeIntegrationEnabled: isProjectNativeIntegrationEnabled
                    },
                    options: {
                        fetchPolicy: $b6e606f8c0a01996$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $b6e606f8c0a01996$export$2e2bcd8739ae039 = $b6e606f8c0a01996$var$atlasProjectEntryPoint;


/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */ function $35e8e01797ae2575$export$68d1d951742105ed(url) {
    // About | Updates | {other tabs}
    if (url.includes('updates')) return 'updates';
    return 'about';
}



var $gWF6I = parcelRequire("gWF6I");








var $i84MD = parcelRequire("i84MD");

const $b818cac8be61238d$var$fetchPolicy = 'network-only';

const $b818cac8be61238d$var$teamPreviewPanelEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("elOiT")).then((mod)=>mod.TeamPreviewPanel), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $i84MD.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $b818cac8be61238d$var$fetchPolicy
                    }
                }
            }
        })
});
var $b818cac8be61238d$export$2e2bcd8739ae039 = $b818cac8be61238d$var$teamPreviewPanelEntryPoint;


const $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project',
    'cmdb-object'
];



var $cgtv4 = parcelRequire("cgtv4");

var $721536e6a2e4576b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    workItem: {
        id: "navigation.preview-panel-global-objects.workItem",
        defaultMessage: "Jira work item"
    },
    project: {
        id: "navigation.preview-panel-global-objects.project",
        defaultMessage: "Project"
    },
    goal: {
        id: "navigation.preview-panel-global-objects.goal",
        defaultMessage: "Goal"
    },
    team: {
        id: "navigation.preview-panel-global-objects.team",
        defaultMessage: "Team"
    },
    page: {
        id: "navigation.preview-panel-global-objects.page",
        defaultMessage: "Confluence Page"
    },
    whiteboard: {
        id: "navigation.preview-panel-global-objects.whiteboard",
        defaultMessage: "Confluence Whiteboard"
    },
    object: {
        id: "navigation.preview-panel-global-objects.object",
        defaultMessage: "Assets Object"
    }
});









var $48FEk = parcelRequire("48FEk");

/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $ibFXh = parcelRequire("ibFXh");

var $aSy6D = parcelRequire("aSy6D");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");




var $8ca7114f2e83ff40$exports = {};
$8ca7114f2e83ff40$exports = new URL("ErrorGeneric.5fda5790.svg", import.meta.url).toString();





const $9e3978ea1fc35db1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorHeader: {
        id: "navigation.preview-panel-global-objects.panels.error-header",
        defaultMessage: "Can\u2019t load details"
    },
    errorDescription: {
        id: "navigation.preview-panel-global-objects.panels.error-description",
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>."
    }
});


const $a06bcd4811576243$var$styles = {
    body: "_bozgxncg _y4tixncg _1q511ejb _85i51ejb"
};
const $a06bcd4811576243$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZVni.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                styles: $a06bcd4811576243$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                    header: formatMessage((0, $9e3978ea1fc35db1$export$defe85febe8b728c).errorHeader),
                    description: formatMessage((0, $9e3978ea1fc35db1$export$defe85febe8b728c).errorDescription, {
                        link: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                href: "https://status.atlassian.com/",
                                children: chunks
                            })
                    }),
                    headingLevel: 2,
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8ca7114f2e83ff40$exports)))
                })
            })
        ]
    });
});


/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");













const $6d87b0f37db700b5$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rko12b0 _1e0c1txw _bfhkizff _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $6d87b0f37db700b5$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZVni.PreviewPanelHeader), {
                onClose: close,
                url: url,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $aSy6D.PreviewPanelBody), {
                styles: $6d87b0f37db700b5$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow4
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow1
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow2
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow3
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $6d87b0f37db700b5$var$styles.skeleton,
                            $6d87b0f37db700b5$var$styles.skeletonRow4
                        ])
                    })
                ]
            })
        ]
    });
});


const $1b27a03431ccc931$var$emptyEntryPointProps = {};
const $1b27a03431ccc931$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $1b27a03431ccc931$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6d87b0f37db700b5$export$97ea7ee86eec0667), {
            ...globalObject
        }),
        errorFallback: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a06bcd4811576243$export$9f31ac9d4b42e91c), {
                ...globalObject
            }),
        runtimeProps: runtimeProps
    });
};


/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");





var $cOrQJ = parcelRequire("cOrQJ");




















const $57b48019462940b6$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $57b48019462940b6$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $57b48019462940b6$export$4e691bca3211cc2f = (url, supportedObjects, rootSourceScreen)=>{
    try {
        const urlObj = new URL(url);
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        if (rootSourceScreen && (0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav')) urlObj.searchParams.set('previewRootSourceScreen', rootSourceScreen);
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs
        if ((0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav')) {
            const encodedRootSource = rootSourceScreen ? `&previewRootSource=${encodeURIComponent(rootSourceScreen)}` : '';
            return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}${encodedRootSource}`;
        } else return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $57b48019462940b6$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};


const $e0021b485e98a5e2$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $e0021b485e98a5e2$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $e0021b485e98a5e2$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes })=>{
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, $42omo.useState)();
    const cloudId = ari ?? $e0021b485e98a5e2$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient = new (0, $a9sR2.default)({
                product: product,
                env: (0, $57b48019462940b6$export$4acedbb0ac692186)(window.location.hostname),
                origin: (0, $5DUgU.originType).WEB
            });
            if (cloudId) analyticsClient?.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
            return analyticsClient;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeSrc = (0, $42omo.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url = new URL(iframeUrl, window.location.origin);
        url.searchParams.set('themeMode', colorMode);
        return url.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZVni.PreviewPanelHeader), {
                onClose: close,
                url: url,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                    title: name,
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                styles: $e0021b485e98a5e2$var$styles.body,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsClient: analyticsClient,
                ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? {
                    analyticsAttributes: analyticsAttributes
                } : {},
                children: /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
                    src: iframeSrc,
                    title: name,
                    className: (0, $gMc0m.default)([
                        $e0021b485e98a5e2$var$styles.iframe
                    ])
                })
            })
        ]
    });
});



const $a7dbab6e358b50cb$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $k4HRJ.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $a7dbab6e358b50cb$export$70bcacea0b970dee = (product, cloudId, options)=>{
    const { enabled: enabled = true, supportedObjects: supportedObjects = (0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251), analyticsAttributes: analyticsAttributes, rootSourceScreen: rootSourceScreen } = options ?? {};
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { open: open } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $42omo.useCallback)(({ ari: ari })=>enabled && supportedObjects.includes($a7dbab6e358b50cb$var$getGlobalObjectType(ari)), [
        enabled,
        supportedObjects
    ]);
    const openPreviewPanel = (0, $42omo.useCallback)(({ url: url, ari: ari, name: name, parentProduct: parentProduct, panelData: panelData })=>{
        const globalObjectType = $a7dbab6e358b50cb$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $57b48019462940b6$export$9f140ed41af5108c)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))) : (0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ)));
                const title = formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).workItem);
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $e0021b485e98a5e2$export$83f0623b6f97b032), {
                    name: title,
                    url: url,
                    iframeUrl: (0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? (0, $57b48019462940b6$export$4e691bca3211cc2f)(url, supportedObjects, rootSourceScreen) : (0, $57b48019462940b6$export$4e691bca3211cc2f)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? {
                        analyticsAttributes: analyticsAttributes
                    } : {}
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                const teamEntryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $b818cac8be61238d$export$2e2bcd8739ae039), {
                    cloudId: cloudId
                });
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                    entryPoint: (0, $b818cac8be61238d$export$2e2bcd8739ae039),
                    preloadedEntryPointReference: teamEntryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        ari: ari,
                        cloudId: cloudId,
                        openPreviewPanel: openPreviewPanel
                    },
                    globalObject: {
                        name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).team),
                        url: url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'people';
                break;
            case 'townsquare-goal':
                const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $ac6dd892357cddb5$export$2e2bcd8739ae039), {
                    ari: ari
                });
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                    entryPoint: (0, $ac6dd892357cddb5$export$2e2bcd8739ae039),
                    preloadedEntryPointReference: entryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        cloudId: cloudId,
                        defaultTab: (0, $35e8e01797ae2575$export$68d1d951742105ed)(url)
                    },
                    globalObject: {
                        name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).goal),
                        url: url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJsgh))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'townsquare';
                break;
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $b6e606f8c0a01996$export$2e2bcd8739ae039), {
                        ari: ari
                    });
                    panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $b6e606f8c0a01996$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $35e8e01797ae2575$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-page':
                {
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $d2a6d778f42989cd$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $d2a6d778f42989cd$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).page),
                            url: formattedUrl,
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $d2a6d778f42989cd$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $d2a6d778f42989cd$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'cmdb-object':
                const assetsEntryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $1a4e8a680740cd08$export$2e2bcd8739ae039), {
                    cloudId: cloudId
                });
                panelContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                    entryPoint: (0, $1a4e8a680740cd08$export$2e2bcd8739ae039),
                    preloadedEntryPointReference: assetsEntryPointReference,
                    runtimeProps: {
                        url: url,
                        parentProduct: product,
                        ari: ari,
                        cloudId: cloudId,
                        openPreviewPanel: openPreviewPanel
                    },
                    // These are fallback properties
                    globalObject: {
                        name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).object),
                        url: url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fwXBL))), {
                            label: ""
                        })
                    }
                });
                panelProduct = 'assetsPreviewPanel';
                break;
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct
            }
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        product,
        cloudId,
        analyticsAttributes,
        rootSourceScreen
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $a7dbab6e358b50cb$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name,
                panelData: payload.panelData
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};



var $bQm3c = parcelRequire("bQm3c");


var $27fJD = parcelRequire("27fJD");


var $eToX6 = parcelRequire("eToX6");

/**
 * Resolves Confluence short links to canonical URLs for preview panels.
 * For Confluence short links (e.g., /wiki/x/ABC123), attempts to construct
 * the canonical URL from preview.href parameters.
 */ const $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl = (originalUrl, response)=>{
    const responseData = response?.data;
    const previewHref = responseData?.preview?.href;
    if (!previewHref) return originalUrl;
    try {
        const previewUrl = new URL(previewHref);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            return `https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`;
        }
    } catch (error) {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
// Helper function to check if previewPanels query parameter is present
const $88a4e0a84f25d5c3$var$hasPreviewPanelsParam = ()=>{
    try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('previewPanels');
    } catch  {
        return false;
    }
};
const $88a4e0a84f25d5c3$var$noop = ()=>{
// this is intentional
};
const $88a4e0a84f25d5c3$export$b92594fec494137a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            supportedObjects: (0, $27fJD.ALL_SUPPORTED_OBJECTS)
        };
        $[0] = t0;
    } else t0 = $[0];
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $a7dbab6e358b50cb$export$70bcacea0b970dee)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId, t0);
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $eIleF.useSmartCardContext)();
    let t1;
    if ($[1] !== cardContext || $[2] !== openAtlasPreviewPanel || $[3] !== openConfluencePagePreviewPanel) {
        const open = (t2)=>{
            const { url: url, ari: ari, panelData: panelData } = t2;
            let resolvedUrl = url;
            if (url.includes("/wiki/x/") && cardContext?.value?.store) {
                const cardState = cardContext.value.store.getState()[url];
                if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
            }
            const name = (0, $k4HRJ.AnyAri).parse(ari).resourceType;
            const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
            if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
                window.parent.postMessage({
                    type: "OPEN_PREVIEW_PANEL",
                    payload: {
                        url: resolvedUrl,
                        ari: ari,
                        name: formattedName,
                        panelData: panelData
                    }
                }, "*");
                return;
            }
            if ((0, $a2xFu.ConfluencePageAri).check(ari)) {
                const urlObj = new URL(resolvedUrl);
                urlObj.searchParams.set("previewPanels", encodeURIComponent((0, $27fJD.ALL_SUPPORTED_OBJECTS).join(",")));
                openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
                return;
            }
            if ((0, $ixcaU.TownsquareGoalAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Goal",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $5JRMI.TownsquareProjectAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Project",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $b8JCF.JiraIssueAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Jira Work Item",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $eMqrF.IdentityTeamAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Team",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
        };
        t1 = {
            open: open
        };
        $[1] = cardContext;
        $[2] = openAtlasPreviewPanel;
        $[3] = openConfluencePagePreviewPanel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $a7dbab6e358b50cb$export$70bcacea0b970dee)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId, {
        supportedObjects: (0, $27fJD.ALL_SUPPORTED_OBJECTS)
    });
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $eIleF.useSmartCardContext)();
    const open = ({ url: url, ari: ari, panelData: panelData })=>{
        let resolvedUrl = url;
        // Only resolve when url is Confluence short links
        if (url.includes('/wiki/x/') && cardContext?.value?.store) {
            const cardState = cardContext.value.store.getState()[url];
            if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
        }
        const name = (0, $k4HRJ.AnyAri).parse(ari).resourceType;
        const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
        if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: resolvedUrl,
                    ari: ari,
                    name: formattedName,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        if ((0, $a2xFu.ConfluencePageAri).check(ari)) {
            const urlObj = new URL(resolvedUrl);
            urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $27fJD.ALL_SUPPORTED_OBJECTS).join(',')));
            openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
            return;
        }
        if ((0, $ixcaU.TownsquareGoalAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Goal',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $5JRMI.TownsquareProjectAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Project',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $b8JCF.JiraIssueAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Jira Work Item',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $eMqrF.IdentityTeamAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Team',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
    };
    return {
        open: open
    };
};
module.exports["useOpenPreviewPanel"] = $88a4e0a84f25d5c3$export$b92594fec494137a;

});

parcelRegister("ixcaU", function(module, exports) {
// src/townsquare/goal/types.ts
var $c06d67ada792527e$export$947838268868cc57 = "townsquare", $c06d67ada792527e$export$935b9c2af9d62e80 = "goal";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/goal/manifest.ts
var $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $c06d67ada792527e$export$947838268868cc57),
    resourceType: (0, $c06d67ada792527e$export$935b9c2af9d62e80),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $d7e4c0c5e4ce08d0$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $d7e4c0c5e4ce08d0$export$e45ea1bd9a289a4f;

});

parcelRegister("2JrHF", function(module, exports) {
/**
 * @generated SignedSource<<92c13806988054530d5f052f4c470121>>
 * @relayHash aedc2a361de666d7cfff73f11d479d63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca31ae70b56a23fd28c76b89727c780874c80ef9ac572e121babd04df2605aaa
const $782e281f79312060$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "goalId",
            "variableName": "ari"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        v7 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "canEditMetrics"
    }, v10 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedGoals"
    }, v11 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v12 = {
        "kind": "ScalarField",
        "name": "canAddLinkedProjects"
    }, v13 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v14 = [
        v5 /*: any*/ ,
        v1 /*: any*/ 
    ], v15 = [
        v1 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = [
        v18 /*: any*/ 
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "TownsquareGoalTypeCustomName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "messageId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "defaultValue"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            v21 /*: any*/ ,
            v22 /*: any*/ 
        ],
        "type": "TownsquareLocalizationField"
    }, v24 = {
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v20 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "kind"
    }, v26 = {
        "kind": "ScalarField",
        "name": "state"
    }, v27 = {
        "kind": "ScalarField",
        "name": "score"
    }, v28 = [
        v18 /*: any*/ ,
        v27 /*: any*/ 
    ], v29 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v28 /*: any*/ 
    }, v30 = {
        "kind": "ScalarField",
        "name": "scoringMode"
    }, v31 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v32 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v33 = {
        "kind": "LinkedField",
        "name": "namePlural",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v19 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomNamePlural"
            },
            v23 /*: any*/ 
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "percentage"
    }, v35 = {
        "kind": "ScalarField",
        "name": "type"
    }, v36 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v38 = {
        "kind": "ScalarField",
        "name": "archived"
    }, v39 = {
        "kind": "ScalarField",
        "name": "externalEntityId"
    }, v40 = {
        "kind": "ScalarField",
        "name": "source"
    }, v41 = {
        "kind": "ScalarField",
        "name": "time"
    }, v42 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v43 = {
        "kind": "Literal",
        "name": "first",
        "value": 100
    }, v44 = {
        "concreteType": "TownsquareGoalState",
        "kind": "LinkedField",
        "name": "newState",
        "plural": false,
        "selections": v28 /*: any*/ 
    }, v45 = {
        "args": [
            v43 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "sort",
                "value": [
                    "TIME_ASC"
                ]
            }
        ],
        "concreteType": "TownsquareMetricValueConnection",
        "kind": "LinkedField",
        "name": "values",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v41 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "origin",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareGoalUpdate",
                                                "kind": "LinkedField",
                                                "name": "goalUpdate",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "TownsquareGoal",
                                                        "kind": "LinkedField",
                                                        "name": "goal",
                                                        "plural": false,
                                                        "selections": v15 /*: any*/ 
                                                    },
                                                    v44 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "TownsquareFromGoalUpdate"
                                    }
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
    }, v46 = [
        v18 /*: any*/ ,
        v1 /*: any*/ 
    ], v47 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "snapshotValue",
        "plural": false,
        "selections": v46 /*: any*/ 
    }, v48 = {
        "kind": "ScalarField",
        "name": "startValue"
    }, v49 = {
        "kind": "ScalarField",
        "name": "targetValue"
    }, v50 = {
        "concreteType": "TownsquareMetricTargetConnection",
        "kind": "LinkedField",
        "name": "metricTargets",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ 
                                ]
                            },
                            v47 /*: any*/ ,
                            v48 /*: any*/ ,
                            v49 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v51 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v52 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v1 /*: any*/ 
        ]
    }, v53 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "start"
            },
            {
                "kind": "ScalarField",
                "name": "end"
            }
        ]
    }, v54 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "targetDate",
        "plural": false,
        "selections": [
            v53 /*: any*/ 
        ]
    }, v55 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v56 = {
        "kind": "ScalarField",
        "name": "missedUpdate"
    }, v57 = {
        "kind": "ScalarField",
        "name": "updateType"
    }, v58 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v59 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v60 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v61 = {
        "args": v55 /*: any*/ ,
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v56 /*: any*/ ,
                            v57 /*: any*/ ,
                            v58 /*: any*/ ,
                            v59 /*: any*/ ,
                            v60 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "updates(first:30)"
    }, v62 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 200
        }
    ], v63 = {
        "concreteType": "TownsquareIconURIs",
        "kind": "LinkedField",
        "name": "iconUrl",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "dark"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "light"
                    }
                ]
            }
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v65 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v66 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v67 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v65 /*: any*/ ,
            v66 /*: any*/ 
        ]
    }, v68 = {
        "args": v62 /*: any*/ ,
        "handle": "connection",
        "key": "GoalContentProjects_projects",
        "kind": "LinkedHandle",
        "name": "projects"
    }, v69 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v70 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v34 /*: any*/ 
        ]
    }, v71 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v72 = [
        v7 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v1 /*: any*/ ,
        v71 /*: any*/ 
    ], v73 = {
        "kind": "ScalarField",
        "name": "label"
    }, v74 = {
        "concreteType": "TownsquareGoalState",
        "kind": "LinkedField",
        "name": "newState",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            v27 /*: any*/ ,
            v73 /*: any*/ 
        ]
    }, v75 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "newValue",
        "plural": false,
        "selections": v46 /*: any*/ 
    }, v76 = {
        "kind": "ScalarField",
        "name": "description"
    }, v77 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v76 /*: any*/ 
    ], v78 = [
        v43 /*: any*/ 
    ], v79 = [
        v73 /*: any*/ 
    ], v80 = [
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v81 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v80 /*: any*/ 
    }, v82 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v80 /*: any*/ 
    }, v83 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v84 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v59 /*: any*/ ,
                            v60 /*: any*/ 
                        ]
                    }
                ]
            },
            v17 /*: any*/ 
        ]
    }, v85 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v58 /*: any*/ ,
                v76 /*: any*/ ,
                v81 /*: any*/ ,
                v82 /*: any*/ ,
                v60 /*: any*/ ,
                v83 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goals_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalPanelTitleField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalType"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalMetrics"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ParentGoal"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "SubGoals"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalActions"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTeams"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalCustomFields"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalUpdateComposerCreate"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "goals_byId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "ari"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "GoalPanelTabs"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goals_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditMetadata"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnGoal"
                                },
                                v11 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedProjects"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddJiraAlignItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveJiraAlignItems"
                                }
                            ]
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v14 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v14 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                }
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v1 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v29 /*: any*/ ,
                        v30 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                        },
                        v31 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v32 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "name",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ],
                                            "type": "TownsquareLocalizationField"
                                        }
                                    ]
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v1 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        },
                        v36 /*: any*/ ,
                        {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMetricTarget",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetric",
                                                    "kind": "LinkedField",
                                                    "name": "metric",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v45 /*: any*/ 
                                                    ]
                                                },
                                                v47 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v36 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v50 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v52 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "args": v62 /*: any*/ ,
                                                    "concreteType": "TownsquareProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "projects",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                },
                                                                v64 /*: any*/ ,
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        v67 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ],
                                                    "storageKey": "projects(first:200)"
                                                },
                                                v68 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v69 /*: any*/ ,
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v70 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v1 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": v72 /*: any*/ 
                                                },
                                                v54 /*: any*/ ,
                                                {
                                                    "args": v55 /*: any*/ ,
                                                    "concreteType": "TownsquareGoalUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updates",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "metricUpdate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareGoalMetricUpdate",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetric",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "metric",
                                                                                                    "plural": false,
                                                                                                    "selections": v15 /*: any*/ 
                                                                                                },
                                                                                                v75 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "updates(first:30)"
                                                },
                                                v30 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetricTargetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTarget",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v45 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v49 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "successMeasures(first:50)"
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                v53 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v1 /*: any*/ ,
                                v36 /*: any*/ ,
                                v50 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                },
                                v2 /*: any*/ ,
                                v51 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v76 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v66 /*: any*/ ,
                                        v65 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        v60 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalTeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canRemove"
                                        },
                                        {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "smallAvatarImageUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVerified"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "profileUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v77 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v77 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v77 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v78 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isUser"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v64 /*: any*/ 
                                                                    ]
                                                                },
                                                                v67 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v78 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v76 /*: any*/ ,
                                                                        {
                                                                            "args": v78 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v78 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v64 /*: any*/ 
                                                                    ]
                                                                },
                                                                v67 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v78 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v38 /*: any*/ ,
                        {
                            "args": v55 /*: any*/ ,
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v58 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v58 /*: any*/ ,
                                                                        v76 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v60 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalMetricUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v35 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v38 /*: any*/ ,
                                                                                v40 /*: any*/ ,
                                                                                v42 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v75 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newStartValue"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newTargetValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                v56 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": v72 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v79 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v71 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v59 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v28 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v79 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v58 /*: any*/ ,
                                                                        v76 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v81 /*: any*/ ,
                                                                        v82 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v83 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareGoalType",
                                                            "kind": "LinkedField",
                                                            "name": "goalType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalType",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "subGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v70 /*: any*/ ,
                                                                                v51 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v52 /*: any*/ ,
                                                                                v54 /*: any*/ ,
                                                                                v61 /*: any*/ ,
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v69 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "successMeasures",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v70 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareGoalType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "goalType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v24 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v1 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v52 /*: any*/ ,
                                                                                v54 /*: any*/ ,
                                                                                v61 /*: any*/ ,
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "successMeasures(first:50)"
                                                        },
                                                        {
                                                            "args": v55 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalUpdateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "updates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalUpdate",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v58 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "updateNotes",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareUpdateNote",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v58 /*: any*/ ,
                                                                                                        v76 /*: any*/ ,
                                                                                                        v1 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "updates(first:30)"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareMetricTargetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "metricTargets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetricTarget",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetric",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metric",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v1 /*: any*/ ,
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareBundledUpdate_extension",
                                                            "kind": "LinkedField",
                                                            "name": "bundledUpdates_extension",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v54 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "owner",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v71 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "update",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v60 /*: any*/ ,
                                                                        v74 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "progress"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v84 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ],
                            "storageKey": "updates(first:30)"
                        },
                        v76 /*: any*/ ,
                        v84 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                        },
                        {
                            "args": v62 /*: any*/ ,
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v64 /*: any*/ ,
                                        {
                                            "concreteType": "TownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v63 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v67 /*: any*/ ,
                                v17 /*: any*/ 
                            ],
                            "storageKey": "projects(first:200)"
                        },
                        v68 /*: any*/ ,
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v85 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v85 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v85 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v62 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "workItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v58 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v64 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                },
                                v67 /*: any*/ ,
                                v17 /*: any*/ 
                            ],
                            "storageKey": "workItems(first:200)"
                        },
                        {
                            "args": v62 /*: any*/ ,
                            "handle": "connection",
                            "key": "GoalContentJira_workItems",
                            "kind": "LinkedHandle",
                            "name": "workItems"
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectUrl"
                                                        }
                                                    ],
                                                    "type": "JiraAlignAggProject"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ca31ae70b56a23fd28c76b89727c780874c80ef9ac572e121babd04df2605aaa",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$782e281f79312060$var$node.hash = "76d2216daae10b2020d305d258bd5628";
var $782e281f79312060$export$2e2bcd8739ae039 = $782e281f79312060$var$node;
module.exports["default"] = $782e281f79312060$export$2e2bcd8739ae039;

});

parcelRegister("fm8ka", function(module, exports) {

let $b2df5e1a46e7265c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2df5e1a46e7265c$var$load("h3ABO"),
    $b2df5e1a46e7265c$var$load("3w411"),
    $b2df5e1a46e7265c$var$load("hGfPD"),
    $b2df5e1a46e7265c$var$load("7Gmjr"),
    $b2df5e1a46e7265c$var$load("jryxA"),
    $b2df5e1a46e7265c$var$load("dWZbK"),
    $b2df5e1a46e7265c$var$load("2YffH"),
    $b2df5e1a46e7265c$var$load("5Y2To"),
    $b2df5e1a46e7265c$var$load("3GzsK"),
    $b2df5e1a46e7265c$var$load("bQUGu"),
    $b2df5e1a46e7265c$var$load("lCT7Q"),
    $b2df5e1a46e7265c$var$load("47RmW"),
    $b2df5e1a46e7265c$var$load("8NOg5"),
    $b2df5e1a46e7265c$var$load("2nTw0"),
    $b2df5e1a46e7265c$var$load("R7cS6"),
    $b2df5e1a46e7265c$var$load("h9Ed7"),
    $b2df5e1a46e7265c$var$load("eBRUf"),
    $b2df5e1a46e7265c$var$load("d63le"),
    $b2df5e1a46e7265c$var$load("l8GL7"),
    $b2df5e1a46e7265c$var$load("gVbhn"),
    $b2df5e1a46e7265c$var$load("iqTGf"),
    $b2df5e1a46e7265c$var$load("19Eqk"),
    $b2df5e1a46e7265c$var$load("lkOIY"),
    $b2df5e1a46e7265c$var$load("32J48"),
    $b2df5e1a46e7265c$var$load("eBY1U"),
    $b2df5e1a46e7265c$var$load("dUz9k"),
    $b2df5e1a46e7265c$var$load("k6h1Q"),
    $b2df5e1a46e7265c$var$load("lz6Bt"),
    $b2df5e1a46e7265c$var$load("3EXzu"),
    $b2df5e1a46e7265c$var$load("2XikM"),
    $b2df5e1a46e7265c$var$load("76iIp"),
    $b2df5e1a46e7265c$var$load("az9CK"),
    $b2df5e1a46e7265c$var$load("8Q66p"),
    $b2df5e1a46e7265c$var$load("aJ9z1"),
    $b2df5e1a46e7265c$var$load("glvWr"),
    $b2df5e1a46e7265c$var$load("eY3St"),
    $b2df5e1a46e7265c$var$load("bkd4T"),
    $b2df5e1a46e7265c$var$load("ks247"),
    $b2df5e1a46e7265c$var$load("deebc"),
    $b2df5e1a46e7265c$var$load("8xx1l"),
    $b2df5e1a46e7265c$var$load("9YBgR"),
    $b2df5e1a46e7265c$var$load("7ZIlR"),
    $b2df5e1a46e7265c$var$load("855o0"),
    $b2df5e1a46e7265c$var$load("8MfZE"),
    $b2df5e1a46e7265c$var$load("hv4mn"),
    $b2df5e1a46e7265c$var$load("6wr18"),
    $b2df5e1a46e7265c$var$load("kjZZD"),
    $b2df5e1a46e7265c$var$load("9ZAzg"),
    $b2df5e1a46e7265c$var$load("kJSYP"),
    $b2df5e1a46e7265c$var$load("Wowvf"),
    $b2df5e1a46e7265c$var$load("kHOMt"),
    $b2df5e1a46e7265c$var$load("dRpV3"),
    $b2df5e1a46e7265c$var$load("ffEVr"),
    $b2df5e1a46e7265c$var$load("dTsOE"),
    $b2df5e1a46e7265c$var$load("hhss7"),
    $b2df5e1a46e7265c$var$load("3yj56"),
    $b2df5e1a46e7265c$var$load("6mG00"),
    $b2df5e1a46e7265c$var$load("3QIea"),
    $b2df5e1a46e7265c$var$load("iqKwT"),
    $b2df5e1a46e7265c$var$load("k0nPy"),
    $b2df5e1a46e7265c$var$load("7EorR"),
    $b2df5e1a46e7265c$var$load("kUbUu"),
    $b2df5e1a46e7265c$var$load("aIokC")
]).then(()=>parcelRequire('jsjFl'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("a4tVd", function(module, exports) {

let $75517cf61e44224d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75517cf61e44224d$var$load("jryxA"),
    $75517cf61e44224d$var$load("dWZbK"),
    $75517cf61e44224d$var$load("k0nPy"),
    $75517cf61e44224d$var$load("8UKe0"),
    $75517cf61e44224d$var$load("5pvpJ"),
    $75517cf61e44224d$var$load("hv4mn"),
    $75517cf61e44224d$var$load("dek7I"),
    $75517cf61e44224d$var$load("dYtBN"),
    $75517cf61e44224d$var$load("kNV5Y"),
    $75517cf61e44224d$var$load("6wr18"),
    $75517cf61e44224d$var$load("kjZZD"),
    $75517cf61e44224d$var$load("9ZAzg"),
    $75517cf61e44224d$var$load("kJSYP"),
    $75517cf61e44224d$var$load("Wowvf"),
    $75517cf61e44224d$var$load("dRpV3"),
    $75517cf61e44224d$var$load("ffEVr"),
    $75517cf61e44224d$var$load("dTsOE"),
    $75517cf61e44224d$var$load("hhss7"),
    $75517cf61e44224d$var$load("3QIea"),
    $75517cf61e44224d$var$load("iqKwT"),
    $75517cf61e44224d$var$load("7EorR"),
    $75517cf61e44224d$var$load("kUbUu"),
    $75517cf61e44224d$var$load("1SiOe")
]).then(()=>parcelRequire('4bE2r'));

});

parcelRegister("fff9r", function(module, exports) {
/**
 * @generated SignedSource<<8f9df8f6a8f77b0ebadf7377c1b976d6>>
 * @relayHash 56a6fc6eadb185ba83c5f5faea6acba2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4b6d921823d34f95054da241072b741a544cc9272c23b4c98d3a90b7ab8ed83
const $4526c1a589f93175$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isProjectNativeIntegrationEnabled"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "ari"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = [
        v1 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        v9 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v13 = {
        "kind": "ScalarField",
        "name": "count"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "canEditMetadata"
    }, v16 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v17 = {
        "kind": "ScalarField",
        "name": "light"
    }, v18 = {
        "kind": "ScalarField",
        "name": "description"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v20 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v21 = {
        "kind": "ScalarField",
        "name": "key"
    }, v22 = {
        "kind": "ScalarField",
        "name": "value"
    }, v23 = [
        v22 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v25 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        v14 /*: any*/ 
    ], v26 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v27 = [
        v21 /*: any*/ ,
        v1 /*: any*/ 
    ], v28 = {
        "kind": "InlineFragment",
        "selections": v7 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v29 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v30 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v31 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v9 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v30 /*: any*/ ,
                            v29 /*: any*/ 
                        ]
                    }
                ]
            },
            v14 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "ScalarField",
            "name": "label"
        }
    ], v33 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v34 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v35 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v36 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v37 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v24 /*: any*/ ,
                v18 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v29 /*: any*/ ,
                v36 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v38 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v18 /*: any*/ 
    ], v39 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v40 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v41 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedWorkItems"
    }, v43 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v44 = {
        "kind": "ScalarField",
        "name": "canAddLinkedWorkItems"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v5 /*: any*/ ,
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "projects_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareContributorEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareContributor",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "userContributor",
                                                        "plural": false,
                                                        "selections": v7 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v8 /*: any*/ ,
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectJiraWork"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelHeader"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectLinks"
                            },
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectWorkTracked"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RelatedProjects"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributesTo"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributors"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectActionsContent"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelTabs"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectCustomFields"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "projects_byId"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "projects_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributor",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "userContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTeamContributor",
                                                    "kind": "LinkedField",
                                                    "name": "teamContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributingMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TeamV2",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "smallAvatarImageUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "profileUrl"
                                                                },
                                                                {
                                                                    "concreteType": "TeamMemberConnectionV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "members",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TeamMemberEdgeV2",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TeamMemberV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "member",
                                                                                            "plural": false,
                                                                                            "selections": v10 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveWatchers"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareWorkspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "roundedSquare",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnProject"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCreateUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                }
                            ]
                        },
                        v21 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isArchived"
                        },
                        {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": v23 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTargetDateRange",
                                    "kind": "LinkedField",
                                    "name": "dateRange",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "start"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "end"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUpdateNoteConnection",
                                    "kind": "LinkedField",
                                    "name": "updateNotes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": v25 /*: any*/ 
                        },
                        {
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v27 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v27 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        v29 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectDependencyConnection",
                            "kind": "LinkedField",
                            "name": "dependencies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependency",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "linkType"
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "incomingProject",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "outgoingProject",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareIconURIs",
                                                            "kind": "LinkedField",
                                                            "name": "iconUrl",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareThemeURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "square",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalTypeIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectDescription",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "what"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "why"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "measurement"
                                }
                            ]
                        },
                        v31 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v24 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v32 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v32 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "archived"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v37 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v37 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v37 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v39 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v40 /*: any*/ 
                                                                    ]
                                                                },
                                                                v41 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v39 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        {
                                                                            "args": v39 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                v22 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v39 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v40 /*: any*/ 
                                                                    ]
                                                                },
                                                                v41 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v39 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        }
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v42 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedJiraWorkItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "permission",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasProjectPermission",
                                                                    "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        v2 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                },
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedJiraWorkItems(first:5)"
                                },
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v44 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v25 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v43 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v44 /*: any*/ ,
                                        v42 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4b6d921823d34f95054da241072b741a544cc9272c23b4c98d3a90b7ab8ed83",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4526c1a589f93175$var$node.hash = "e65b0c1cff179f718b3db2224d665ed5";
var $4526c1a589f93175$export$2e2bcd8739ae039 = $4526c1a589f93175$var$node;
module.exports["default"] = $4526c1a589f93175$export$2e2bcd8739ae039;

});

parcelRegister("iBezP", function(module, exports) {

let $d8a6fd5ed1e4b9f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8a6fd5ed1e4b9f9$var$load("h3ABO"),
    $d8a6fd5ed1e4b9f9$var$load("3w411"),
    $d8a6fd5ed1e4b9f9$var$load("hGfPD"),
    $d8a6fd5ed1e4b9f9$var$load("7Gmjr"),
    $d8a6fd5ed1e4b9f9$var$load("jryxA"),
    $d8a6fd5ed1e4b9f9$var$load("dWZbK"),
    $d8a6fd5ed1e4b9f9$var$load("2YffH"),
    $d8a6fd5ed1e4b9f9$var$load("3l6zb"),
    $d8a6fd5ed1e4b9f9$var$load("lVO3w"),
    $d8a6fd5ed1e4b9f9$var$load("hyzoX"),
    $d8a6fd5ed1e4b9f9$var$load("lCT7Q"),
    $d8a6fd5ed1e4b9f9$var$load("47RmW"),
    $d8a6fd5ed1e4b9f9$var$load("8NOg5"),
    $d8a6fd5ed1e4b9f9$var$load("2nTw0"),
    $d8a6fd5ed1e4b9f9$var$load("R7cS6"),
    $d8a6fd5ed1e4b9f9$var$load("h9Ed7"),
    $d8a6fd5ed1e4b9f9$var$load("eBRUf"),
    $d8a6fd5ed1e4b9f9$var$load("d63le"),
    $d8a6fd5ed1e4b9f9$var$load("l8GL7"),
    $d8a6fd5ed1e4b9f9$var$load("gVbhn"),
    $d8a6fd5ed1e4b9f9$var$load("iqTGf"),
    $d8a6fd5ed1e4b9f9$var$load("lkOIY"),
    $d8a6fd5ed1e4b9f9$var$load("32J48"),
    $d8a6fd5ed1e4b9f9$var$load("eBY1U"),
    $d8a6fd5ed1e4b9f9$var$load("dUz9k"),
    $d8a6fd5ed1e4b9f9$var$load("k6h1Q"),
    $d8a6fd5ed1e4b9f9$var$load("lz6Bt"),
    $d8a6fd5ed1e4b9f9$var$load("3EXzu"),
    $d8a6fd5ed1e4b9f9$var$load("2XikM"),
    $d8a6fd5ed1e4b9f9$var$load("76iIp"),
    $d8a6fd5ed1e4b9f9$var$load("az9CK"),
    $d8a6fd5ed1e4b9f9$var$load("8Q66p"),
    $d8a6fd5ed1e4b9f9$var$load("aJ9z1"),
    $d8a6fd5ed1e4b9f9$var$load("glvWr"),
    $d8a6fd5ed1e4b9f9$var$load("eY3St"),
    $d8a6fd5ed1e4b9f9$var$load("bkd4T"),
    $d8a6fd5ed1e4b9f9$var$load("ks247"),
    $d8a6fd5ed1e4b9f9$var$load("5CdWD"),
    $d8a6fd5ed1e4b9f9$var$load("deebc"),
    $d8a6fd5ed1e4b9f9$var$load("8xx1l"),
    $d8a6fd5ed1e4b9f9$var$load("9YBgR"),
    $d8a6fd5ed1e4b9f9$var$load("7ZIlR"),
    $d8a6fd5ed1e4b9f9$var$load("855o0"),
    $d8a6fd5ed1e4b9f9$var$load("8MfZE"),
    $d8a6fd5ed1e4b9f9$var$load("hv4mn"),
    $d8a6fd5ed1e4b9f9$var$load("6wr18"),
    $d8a6fd5ed1e4b9f9$var$load("kjZZD"),
    $d8a6fd5ed1e4b9f9$var$load("9ZAzg"),
    $d8a6fd5ed1e4b9f9$var$load("kJSYP"),
    $d8a6fd5ed1e4b9f9$var$load("Wowvf"),
    $d8a6fd5ed1e4b9f9$var$load("kHOMt"),
    $d8a6fd5ed1e4b9f9$var$load("dRpV3"),
    $d8a6fd5ed1e4b9f9$var$load("ffEVr"),
    $d8a6fd5ed1e4b9f9$var$load("dTsOE"),
    $d8a6fd5ed1e4b9f9$var$load("hhss7"),
    $d8a6fd5ed1e4b9f9$var$load("3yj56"),
    $d8a6fd5ed1e4b9f9$var$load("6mG00"),
    $d8a6fd5ed1e4b9f9$var$load("3QIea"),
    $d8a6fd5ed1e4b9f9$var$load("iqKwT"),
    $d8a6fd5ed1e4b9f9$var$load("k0nPy"),
    $d8a6fd5ed1e4b9f9$var$load("7EorR"),
    $d8a6fd5ed1e4b9f9$var$load("kUbUu"),
    $d8a6fd5ed1e4b9f9$var$load("aPnpL")
]).then(()=>parcelRequire('2WJhA'));

});

parcelRegister("i84MD", function(module, exports) {
/**
 * @generated SignedSource<<be9d76f63db93553bbb649b37a6b4c41>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $b0e79b658ff3836d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0e79b658ff3836d$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $b0e79b658ff3836d$export$2e2bcd8739ae039 = $b0e79b658ff3836d$var$node;
module.exports["default"] = $b0e79b658ff3836d$export$2e2bcd8739ae039;

});

parcelRegister("elOiT", function(module, exports) {

let $a72a0c19cc6dfdae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a72a0c19cc6dfdae$var$load("k6h1Q"),
    $a72a0c19cc6dfdae$var$load("lz6Bt"),
    $a72a0c19cc6dfdae$var$load("g9CVe"),
    $a72a0c19cc6dfdae$var$load("8xx1l"),
    $a72a0c19cc6dfdae$var$load("3yj56"),
    $a72a0c19cc6dfdae$var$load("6mG00"),
    $a72a0c19cc6dfdae$var$load("jryxA"),
    $a72a0c19cc6dfdae$var$load("dWZbK"),
    $a72a0c19cc6dfdae$var$load("eVYW1"),
    $a72a0c19cc6dfdae$var$load("020xd"),
    $a72a0c19cc6dfdae$var$load("eTBsW"),
    $a72a0c19cc6dfdae$var$load("1oiJ6"),
    $a72a0c19cc6dfdae$var$load("lPQcc"),
    $a72a0c19cc6dfdae$var$load("9DLLg"),
    $a72a0c19cc6dfdae$var$load("jvHRs"),
    $a72a0c19cc6dfdae$var$load("4JHkq"),
    $a72a0c19cc6dfdae$var$load("gWfLJ"),
    $a72a0c19cc6dfdae$var$load("3GDEr"),
    $a72a0c19cc6dfdae$var$load("64UoX"),
    $a72a0c19cc6dfdae$var$load("lDkw4"),
    $a72a0c19cc6dfdae$var$load("3l6zb"),
    $a72a0c19cc6dfdae$var$load("hyzoX"),
    $a72a0c19cc6dfdae$var$load("fGTig"),
    $a72a0c19cc6dfdae$var$load("iqTGf"),
    $a72a0c19cc6dfdae$var$load("31bKg"),
    $a72a0c19cc6dfdae$var$load("jbxHq"),
    $a72a0c19cc6dfdae$var$load("9XYQ9"),
    $a72a0c19cc6dfdae$var$load("76iIp"),
    $a72a0c19cc6dfdae$var$load("az9CK"),
    $a72a0c19cc6dfdae$var$load("bCoB0"),
    $a72a0c19cc6dfdae$var$load("ht6hk"),
    $a72a0c19cc6dfdae$var$load("eY3St"),
    $a72a0c19cc6dfdae$var$load("bkd4T"),
    $a72a0c19cc6dfdae$var$load("1Y6tF"),
    $a72a0c19cc6dfdae$var$load("hv4mn"),
    $a72a0c19cc6dfdae$var$load("jMj86"),
    $a72a0c19cc6dfdae$var$load("b2FtX"),
    $a72a0c19cc6dfdae$var$load("dYtBN"),
    $a72a0c19cc6dfdae$var$load("6wr18"),
    $a72a0c19cc6dfdae$var$load("kjZZD"),
    $a72a0c19cc6dfdae$var$load("9ZAzg"),
    $a72a0c19cc6dfdae$var$load("kJSYP"),
    $a72a0c19cc6dfdae$var$load("Wowvf"),
    $a72a0c19cc6dfdae$var$load("kHOMt"),
    $a72a0c19cc6dfdae$var$load("dRpV3"),
    $a72a0c19cc6dfdae$var$load("ffEVr"),
    $a72a0c19cc6dfdae$var$load("dTsOE"),
    $a72a0c19cc6dfdae$var$load("hhss7"),
    $a72a0c19cc6dfdae$var$load("3QIea"),
    $a72a0c19cc6dfdae$var$load("iqKwT"),
    $a72a0c19cc6dfdae$var$load("k0nPy"),
    $a72a0c19cc6dfdae$var$load("7EorR"),
    $a72a0c19cc6dfdae$var$load("kUbUu"),
    $a72a0c19cc6dfdae$var$load("9SyhI"),
    $a72a0c19cc6dfdae$var$load("jRc59")
]).then(()=>parcelRequire('eK8NE'));

});

parcelRegister("27fJD", function(module, exports) {

var $a2xFu = parcelRequire("a2xFu");

var $eMqrF = parcelRequire("eMqrF");

var $b8JCF = parcelRequire("b8JCF");

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");


var $eToX6 = parcelRequire("eToX6");

const $8d12b9c9b8a8c583$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project'
];
const $8d12b9c9b8a8c583$export$9e4592d635e5db5b = ({ ari: ari })=>{
    const href = window?.location?.href;
    if (href) {
        const searchParams = new URL(href).searchParams;
        if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') return false;
        if ((0, $eToX6.isInIframe)() && !(0, $eToX6.hasPreviewPanelIndicators)(searchParams)) return false;
    }
    if ((0, $a2xFu.ConfluencePageAri).check(ari)) return true;
    if ((0, $b8JCF.JiraIssueAri).check(ari)) return true;
    if ((0, $ixcaU.TownsquareGoalAri).check(ari)) return true;
    if ((0, $5JRMI.TownsquareProjectAri).check(ari)) return true;
    if ((0, $eMqrF.IdentityTeamAri).check(ari)) return true;
    return false;
};
module.exports["ALL_SUPPORTED_OBJECTS"] = $8d12b9c9b8a8c583$export$cec6f7cb9c99f251;
module.exports["isPreviewPanelAvailable"] = $8d12b9c9b8a8c583$export$9e4592d635e5db5b;

});


$parcel$global.rlb("8PPsf")
//# sourceMappingURL=FullPageEditorComponent.f1d67a6a.js.map
